// extracted by mini-css-extract-plugin
module.exports = {"dateSwitcher":"styles_dateSwitcher__373iJ","icon":"styles_icon__S-4Hl","label":"styles_label__aCb_6"};